import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router-dom'
import { noop } from 'lodash'
import { colors, breakpoints, structure, zIndex } from '@/styles'
import { Button } from '@/components/button'
import useIsMobile from '@/hooks/use-is-mobile'
import ProgressBar from './progress-bar'
import SignContractHeaderLogo from './sign-contract-header-logo.svg'
import SignContractCloseIcon from './sign-contract-header-close-icon.svg'

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  height: ${structure.header.height}px;
  z-index: ${zIndex.buttonBar};
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.grey};
  transition: all 0.2s ease;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    height: ${structure.header.heightMobile}px;
    width: 100%;
  }

  @media print {
    position: static;
  }
`

const HeaderInner = styled.div`
  ${props =>
    props.isMobile
      ? 'display: flex; justify-content: space-between;'
      : 'display: grid; grid-template-columns: 3fr 1fr;'}

  width: 100%;
  display: flex;
  height: 100%;
  max-width: 1330px;
  padding: 0 30px;
  margin-right: auto;
  margin-left: auto;
  align-items: center;
  ${props => (props.isSigning ? 'justify-content: space-between;' : 'justify-content: center;')}

  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: initial;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    align-items: center;
    padding: 0 25px;
  }

  p {
    font-size: 14px;
    ${props => (props.isSigning ? 'font-weight: 500;' : 'font-weight: 700;')}
  }
`

const ContentWrapper = styled.div`
  grid-column-start: 3;
  padding: 12px 0;
`
const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`
const ProgressBarWrapper = styled.div`
  width: ${props => (props.isEdit ? '225px' : '804px')};
  margin: 10px 0 40px 57px;
  padding-right: 40px;
`

const StyledIcon = styled.img``

const StyledButton = styled(Button)`
  width: 32px;
  height: 32px;
`

const Header = ({ currentStep, contract, handleRedirect = noop, isEdit = false }) => {
  const isMobile = useIsMobile()
  const history = useHistory()
  const location = useLocation()
  const isSigning = location.pathname.includes('/custom-contract/sign')
  const handleClick = isSigning ? handleRedirect : history.goBack
  return (
    <HeaderContainer>
      <HeaderInner isMobile isSigning>
        {!isMobile && !isSigning && (
          <ProgressBarContainer>
            <ProgressBarWrapper isEdit={isEdit}>
              <ProgressBar currentStep={currentStep} isEdit={isEdit} />
            </ProgressBarWrapper>
          </ProgressBarContainer>
        )}
        {isMobile && (
          <>
            <img src={SignContractHeaderLogo} alt="icon" />
          </>
        )}
        {isSigning && <p>{contract?.building?.full_address}</p>}
      </HeaderInner>
    </HeaderContainer>
  )
}

export default Header
